import { defaultData, FormDataT, TableCompanyDataT } from "./constants";
import { AddressT } from "ui-io/company-io";

export const reloadPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};
export const parseCSVToJSON = (csvText: string) => {
  const lines = csvText.trim().split("\n");
  const headers = lines[0].split(",").map((header) => header.trim());
  const rows = lines.slice(1).map((line) => {
    const row: string[] = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === "," && !inQuotes) {
        row.push(current.trim());
        current = "";
      } else {
        current += char;
      }
    }
    row.push(current.trim());
    const obj: Record<string, string> = {};
    headers.forEach((header, i) => {
      obj[header] = row[i] ?? "";
    });
    return obj;
  });
  return { headers, rows };
};

export const getDayFromCron = (
	cron: string
): string => {
	if (!cron) return "Custom";

	const parts = cron.trim().split(" ");
	if (parts.length !== 6) return "Custom";
	
	const [sec, min, hour, dayOfMonth, month, dayOfWeek] = parts;
	if (cron === "0 0 12 * * ?") return "Daily";
	if (sec === "0" && min === "0" && hour === "12" && dayOfMonth === "?" && month === "*" && /^[1-7]$/.test(dayOfWeek)) {
		return "Weekly";
	}
	if (sec === "0" && min === "0" && hour === "12" && dayOfMonth !== "*" && month === "1/1" && dayOfWeek === "?") {
		return "Monthly";
	}
	if (sec === "0" && min === "0" && hour === "12" && dayOfMonth !== "*" && month === "1/3" && dayOfWeek === "?") {
		return "Quarterly";
	}
	if (sec === "0" && min === "0" && hour === "12" && dayOfMonth !== "*" && month === "1/6" && dayOfWeek === "?") {
		return "Biannually";
	}
	if (sec === "0" && min === "0" && hour === "12" && dayOfMonth !== "*" && month === "1/12" && dayOfWeek === "?") {
		return "Yearly";
	}

	return "Custom";
};
export const getDateFromCron = (cron: string): Date | null => {
  if (!cron) return null;

  const parts = cron.trim().split(" ");
  if (parts.length !== 6) return null;

  const [sec, min, hour, dayOfMonth, month, dayOfWeek] = parts;
  const now = new Date();

  if (cron === "0 0 12 * * ?") return now;

  if (sec === "0" && min === "0" && hour === "12" && dayOfMonth === "?" && month === "*" && /^[1-7]$/.test(dayOfWeek)) {
    const targetDay = Number(dayOfWeek) % 7; 
    const diff = (targetDay - now.getDay() + 7) % 7;
    const nextDate = new Date(now);
    nextDate.setDate(now.getDate() + diff - 1);
		console.log("nextDate",nextDate)
    return nextDate;
  }

  const day = Number(dayOfMonth);

  if (sec === "0" && min === "0" && hour === "12" && month === "*" && dayOfWeek === "?") {
    let next = new Date(now.getFullYear(), now.getMonth(), day);
    if (next < now) next = new Date(now.getFullYear(), now.getMonth() + 1, day);
    return next;
  }

  if (sec === "0" && min === "0" && hour === "12" && month === "1/1" && dayOfWeek === "?") {
    let next = new Date(now.getFullYear(), now.getMonth(), day, 12, 0, 0, 0);
    if (next < now) next = new Date(now.getFullYear(), now.getMonth() + 1, day, 12, 0, 0, 0);
    return next;
  }

  if (month === "1/3") {
    const cycleMonths = [0, 3, 6, 9];
    let next = findNextMonthMatch(cycleMonths, day, now);
    return next;
  }
  if (month === "1/6") {
    const cycleMonths = [0, 6];
    let next = findNextMonthMatch(cycleMonths, day, now);
    return next;
  }

  if (month === "1/12") {
    const cycleMonths = [0];
    let next = findNextMonthMatch(cycleMonths, day, now);
    return next;
  }

  return null;
};
function findNextMonthMatch(cycleMonths: number[], day: number, now: Date): Date {
  const currentYear = now.getFullYear();

  for (const m of cycleMonths) {
    const next = new Date(currentYear, m, day);
    if (next >= now) return next;
  }
  return new Date(currentYear + 1, cycleMonths[0], day);
}


export function generateCron(mode: string, date: Date|null): string {
  if (!date) return "";

  const dayNumber = date.getDate();
  let dayNameNumber = date.getDay() + 1;

  switch (mode) {
    case "Daily":
      return `0 0 12 * * ?`;

    case "Weekly":
      return `0 0 12 ? * ${dayNameNumber}`;

    case "Monthly":
      return `0 0 12 ${dayNumber} 1/1 ?`;

    case "Quarterly":
      return `0 0 12 ${dayNumber} 1/3 ?`;

    case "Biannually":
      return `0 0 12 ${dayNumber} 1/6 ?`;

    case "Yearly":
      return `0 0 12 ${dayNumber} 1/12 ?`;

    default:
      return "";
  }
}

//used for configPage

export const transformCompanyData = (inputData: TableCompanyDataT[]) => {
  return inputData.map((item) => ({
    name: item.company_name,
    company_type: item.company_type,
    licence_no: item.company_number,
    description: "",
    status: item.company_status,
    incorporation_date: item.incorporation_date,
    industry: {
      sic_code: item.nature_of_business || "",
      lsic_code: item.nature_of_business || "",
    },
    address: [
      {
        full_address: item.registered_office_address,
        street: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
        type: "REGISTERED",
      },
    ],
    url: {
      website: "",
      logo: "",
      linkedin: "",
      twitter: "",
    },
  }));
};
export const deepMerge = (target: any, source: any): any => {
  if (Array.isArray(target) && Array.isArray(source)) {
    return source;
  }
  if (typeof target !== "object" || target === null) return source;
  if (typeof source !== "object" || source === null) return target;

  const merged = { ...target };
  for (const key of Object.keys(source)) {
    if (key in target) {
      merged[key] = deepMerge(target[key], source[key]);
    } else {
      merged[key] = source[key];
    }
  }
  return merged;
};
export const isEmptyObject = (item: any): boolean => {
  if (item === null || item === undefined) return true;
  if (typeof item !== "object") return false;

  return Object.values(item).every((val) => {
    if (val === null || val === "") return true;
    if (typeof val === "object") return isEmptyObject(val);
    return false;
  });
};
export const initializeFormData = (
  companyDetail: any,
  companyConfig: any,
  setFormData: React.Dispatch<React.SetStateAction<FormDataT>>,
  setTagValues: React.Dispatch<React.SetStateAction<string[]>>,
  setBadgeValues: React.Dispatch<React.SetStateAction<(string|null)[]>>,
  setCategoryValues: React.Dispatch<React.SetStateAction<string[]>>
) => {
  let updatedFormData = {...defaultData};
  if (companyConfig && Object.keys(companyConfig).length > 0) {
    updatedFormData.configDetail = { ...companyConfig };
  }
  if (companyDetail && Object.keys(companyDetail).length > 0) {
    updatedFormData.companyDetail = { ...companyDetail };
    
    if (companyDetail?.address) {
      updatedFormData.companyDetail.addresses = companyDetail.address.map((ele: any) => {
        const { _id, ...rest } = ele;
        return rest;
      });
    }
  }

  let validStatementType = ["cs01", "sh01"];
  let presentStatementType = updatedFormData?.configDetail?.share_allotment?.length
    ? updatedFormData.configDetail.share_allotment.map((item: any) => item.statement_type)
    : [];

  let remainingStatementType =
    validStatementType.filter((e: any) => !presentStatementType.includes(e)) || [];

  let shareAllotmentArray = Array.isArray(updatedFormData.configDetail.share_allotment) 
    ? [...updatedFormData.configDetail.share_allotment] 
    : [];

  if (
		Array.isArray(defaultData?.configDetail?.share_allotment) &&
		defaultData.configDetail.share_allotment.length >= 2
  ) {
		if (
			remainingStatementType.includes("cs01") &&
			remainingStatementType.includes("sh01")
		) {
			shareAllotmentArray.push(
				defaultData.configDetail.share_allotment[0],
				defaultData.configDetail.share_allotment[1]
			);
		} else if (remainingStatementType.includes("cs01")) {
			shareAllotmentArray.push(
				defaultData.configDetail.share_allotment[0]
			);
		} else if (remainingStatementType.includes("sh01")) {
			shareAllotmentArray.push(
				defaultData.configDetail.share_allotment[1]
			);
		}
  }


  // Sort the array
  updatedFormData.configDetail.share_allotment = shareAllotmentArray.sort((a, b) =>
    a.statement_type.localeCompare(b.statement_type)
  );
  setFormData(updatedFormData);

  // Set other state values
  if (companyDetail?.data?.tags) {
    setTagValues(companyDetail.data.tags);
  }
  if (companyDetail?.data?.badges) {
    setBadgeValues(companyDetail.data.badges);
  }
  if (companyDetail?.data?.industry?.category) {
    setCategoryValues(companyDetail.data.industry.category);
  }
};
export const getAddress = (addresses: AddressT[]) => {
  return addresses.map((addr) => {
    const parts = [
      addr.street,
      addr.city,
      addr.state,
      addr.country,
      addr.postal_code,
    ].filter(Boolean);

    return {
      ...addr,
      full_address: parts.join(", "),
    };
  });
};
